import { render } from "./logo-menu.vue?vue&type=template&id=1bc9817c&scoped=true"
const script = {}

import "./logo-menu.vue?vue&type=style&index=0&id=1bc9817c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc9817c"]])

export default __exports__